import React, { FC } from 'react';
import { Box, Indicator } from '@mantine/core';
import { useStyles } from './styles';
import { IRowData, IUsersSortField } from '@components/simple-table/types';
import { UserStatusEnum } from '@/types/enums/user';
import { IPosition } from '@/entities/admin-app/user';
import OverflowTip from '@components/OverflowTip';
import { IconX } from '@tabler/icons';
import { UserAvatarWithCard } from '@/components/user-avatar-with-card';

interface IItemUserProps {
  item?: IRowData;
}

const ItemUser: FC<IItemUserProps> = ({ item }) => {
  const { classes } = useStyles();

  const isBan = item?.Status === UserStatusEnum.Ban;
  const isLdapUser = item?.Type === IUsersSortField.LDAP;

  return (
    <Box className={classes.user}>
      {isBan && (
        <Indicator
          withBorder
          label={<IconX size="8" stroke="4" />}
          size={20}
          offset={6}
          position="bottom-start"
          color="red"
        >
          <UserAvatarWithCard
            hoverCardProps={{ position: 'right' }}
            user={item}
            size={40}
            src={item?.Avatar}
          />
        </Indicator>
      )}
      {!isBan && (
        <UserAvatarWithCard
          hoverCardProps={{ position: 'right' }}
          user={item}
          size={40}
          src={item?.Avatar}
        />
      )}
      {isLdapUser && <Box className={classes.ldapLabel}>LDAP</Box>}
      <Box className={classes.content} maw="200px">
        <Box maw="200px" className={classes.nameWrapper}>
          <OverflowTip size="sm" fw={600} color="#101828">
            {item?.Name}
          </OverflowTip>
          {isLdapUser && <Box className={classes.ldapLabel}>LDAP</Box>}
        </Box>
        {item?.Positions?.length &&
          item?.Positions?.slice(0, 2).map((position: IPosition, index: number) => (
            <Box className={classes.nameWrapper} key={index} maw="200px">
              <OverflowTip size="xs" fw={400}>
                {position?.Position}
              </OverflowTip>
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default React.memo(ItemUser);
